<template>
    <div style="background:#FFF;">
        <h3 class="title-bar clearfix">
            <span>{{ $t('首检') }}</span>
            <Button type="primary" style="margin-left: 10px;" @click="reportSubmit" :loading="loading" v-if="!readOnly" :disabled="submitDisabled">{{$t('提交')}}</Button>
            <Button type="primary" style="margin-left: 8px;" @click="downloadReport" :loading="loading" v-if="readOnly">{{ $t('打印下载检验报告') }}</Button>
        </h3>
        
        <div style="padding: 10px 20px;">
            <custom-panel name="1" :gutter="false">
                {{ $t('批次信息') }}
                <div slot="content">
                    <div style="background:#FFF;padding:10px 20px 10px 0;">
                        <Form :label-width="85" :model="reportObj" ref="reportForm" :rules="reportRules">
                            <Row>
                                <Col :span="6">
                                    <FormItem :label="$t('批次检验单号')">
                                        <Input type="text" disabled v-model="reportObj.reportNumber" :title="reportObj.reportNumber"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('有效日期')" required>
                                        <Row>
                                            <Col :span="11">
                                                <FormItem label="" prop="validStartTime">
                                                    <DatePicker
                                                        v-model="reportObj.validStartTime" 
                                                        type="datetime"
                                                        transfer
                                                        disabled
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        style="width:100%"
                                                        :options="dataOptions"
                                                    />
                                                </FormItem>
                                            </Col>
                                            <Col :span="2">-</Col>
                                            <Col :span="11">
                                                <FormItem label="" prop="validEndTime">
                                                    <DatePicker 
                                                        v-model="reportObj.validEndTime" 
                                                        type="datetime"
                                                        transfer
                                                        disabled
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        style="width:100%"
                                                    />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('事业部')">
                                        <Input type="text" disabled v-model="reportObj.buName" :title="reportObj.buName"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('通用标准版本')">
                                        <Input
                                            v-model="reportObj.commonStandardsName"
                                            type="text"
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                    <FormItem :label="$t('供方名称')">
                                        <Input type="text" disabled v-model="reportObj.vendorNameAlt" :title="reportObj.vendorNameAlt"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('物料编码')">
                                        <Input type="text" disabled v-model="reportObj.itemCode" :title="reportObj.itemCode"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('物料描述')">
                                        <Input type="text" disabled v-model="reportObj.itemDescription" :title="reportObj.itemDescription"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('特殊标准版本')">
                                        <Input type="text" disabled v-model="reportObj.specialStandardsName"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                    <FormItem :label="$t('生产数量')" prop="checkQuantity">
                                        <Input type="text" disabled v-model="reportObj.checkQuantity"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('检测水平')">
                                        <Input type="text" disabled v-model="reportObj.inspectionLevelTl"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('严格度')">
                                        <Input type="text" disabled v-model="reportObj.examinedStringencyTl"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('检验结果')">
                                        <Input type="text" disabled v-model="reportObj.inspectionResultT1"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                    <FormItem :label="$t('一次性采购')">
                                        <Input type="text" disabled v-model="reportObj.onetimePurchaseFlagTl"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('试验品')">
                                        <Input type="text" disabled v-model="reportObj.trialFlagTl"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('固定样本')">
                                        <Input type="text" disabled v-model="reportObj.sampleQty"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('检验标准')">
                                        <Input type="text" disabled v-model="reportObj.groupFlagName"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                    <FormItem :label="$t('检验员')" prop="checker">
                                        <Input type="text" v-model="reportObj.checker" :disabled="readOnly"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('批次号')" prop="batchNumber">
                                        <Input type="text" v-model="reportObj.batchNumber" :disabled="readOnly"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <FormItem :label="$t('产地-品牌')" prop="placeBrand">
                                        <Input type="text" v-model="reportObj.placeBrand" :disabled="readOnly"/>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </custom-panel>

            <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                {{ $t('计量检验') }}
                <!--<template v-if="!readOnly">
                    <Button style="margin-left:10px;" type="primary" @click="importMeasure($event, true)">{{ $t('导入计量检验') }}</Button>
                    <Button style="margin-left:10px;" type="primary" @click="importMeasure($event, false)" :loading="importModal.loading">{{ $t('导出计量检验') }}</Button>
                </template>
                -->
                <div slot="content">
                    <div style="width:100%;overflow-x:auto;">
                        <table cellspacing="0" cellpadding="0" ref="tbody" border="0" class="table" :style="{'min-width': tableWidth + 'px', width: '100%'}">
                            <tr>
                                <th width="50">
                                    <span>{{ $t('项目类别') }}</span>
                                </th>
                                <th width="60">
                                    <span>{{ $t('项目名称') }}</span>
                                </th>
                                <th width="40">
                                    <span>{{ $t('单位') }}</span>
                                </th>
                                <th width="50">
                                    <span>{{ $t('特性分级') }}</span>
                                </th>
                                <th width="50">
                                    <span>{{ $t('检验工具') }}</span>
                                </th>
                                <th width="50">
                                    <span>{{ $t('检验水平') }}</span>
                                </th>
                                <th width="40">
                                    <span>{{ $t('样本数') }}</span>
                                </th>
                                <th width="60" align="center">
                                    {{ $t('检验结果') }}
                                </th>
                                <th width="40">
                                    <span>{{ $t('不良数') }}</span>
                                </th>
                                <th width="60">
                                    <span>{{ $t('最小值') }}</span>
                                </th>
                                <th width="60">
                                    <span>{{ $t('最大值') }}</span>
                                </th>
                                <th width="40">
                                    <span>{{ $t('基准值') }}</span>
                                </th>
                                <th width="46" v-for="(i, key) in [1, 2, 3, 4, 5]" :key="key">
                                    <span>{{$t('测量值')}}{{ key + 1}}</span>
                                </th>
                                <th width="120">
                                    <span>{{ $t('检验依据') }}</span>
                                </th>
                            </tr>
                            <tbody ref="tableTrBodylineMetering">
                                <tr v-for="(item, index) in lineMetering"
                                    @click="trOnClick(index, 'lineMetering')" 
                                    :key="index" 
                                    :ref="`tableTrlineMetering${index}`"
                                >
                                    <td>
                                        {{item.itemsCategoryTl}}
                                    </td>
                                    <td>
                                        {{item.itemsName}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyUom}}
                                    </td>
                                    <td>
                                        {{item.itemsLevel}}
                                    </td>
                                    <td>
                                        {{item.examinedTool}}
                                    </td>
                                    <td>
                                        {{item.inspectionLevelTl}}
                                    </td>
                                    <td>
                                        {{item.sampleQty}}
                                    </td>
                                    <td>
                                        <div style="padding:0 5px;">
                                            <Select placeholder="" 
                                                v-model="item.checkedResult"
                                                :disabled="readOnly"
                                                @on-change="(val) => checkedResultChange(val, index, 'lineMetering')"
                                            >
                                                <Option v-for="item2 in checkResultList2"
                                                    :value="item2.value"
                                                    :disabled="item2.value === 'OK'"
                                                    :key="item2.value"
                                                >
                                                    {{item2.label}}
                                                </Option>
                                            </Select>
                                        </div>
                                    </td>
                                    <td>
                                        {{item.ngQty}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyFloorTerms}}{{item.itemsPropertyFloor}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyCeilingTerms}}{{item.itemsPropertyCeiling}}
                                    </td>
                                    <td>
                                        {{item.itemsPropertyBenchmark}}
                                    </td>
                                    <td v-for="(i, key2) in 5" :key="key2">
                                        <div v-if="key2 + 1 <= inputArrayList[index]">
                                            <Input
                                                v-if="reLoad"
                                                v-model="item.sampleMeteringCount[key2]"
                                                :disabled="item.checkedResult === 'NA' || readOnly"
                                                class="report-input number-input"
                                                @on-blur="sampleMeteringOnChange(item, item.sampleMeteringCount[key2], index, key2, item.itemsPropertyFloorTerms, item.itemsPropertyCeilingTerms, true)"
                                                @on-keydown="nextInput($event, index, key2)"
                                            >
                                            </Input>
                                            <span v-show="!reLoad">-</span>
                                        </div>
                                        <div v-else style="text-align:center">-</div>
                                    </td>
                                    <td>
                                        {{item.examinedBasis}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </custom-panel>

            <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                {{ $t('计数检验') }}
                <div slot="content">
                    <table cellspacing="0" cellpadding="0" ref="tbody" border="0" style="width: 100%;" class="table" :style="{'min-width': tableWidth + 'px'}">
                        <tr>
                            <th width="80">
                                {{ $t('项目类别') }}
                            </th>
                            <th width="100">
                                {{ $t('项目名称') }}
                            </th>
                            <th width="80">
                                {{ $t('技术要求') }}
                            </th>
                            <th width="70">
                                {{ $t('特性分级') }}
                            </th>
                            <th width="100">
                                {{ $t('检验工具') }}
                            </th>
                            <th width="100">
                                {{ $t('检验水平') }}
                            </th>
                            <th width="60">
                                {{ $t('样本数') }}
                            </th>
                            <th width="70" align="center">
                                {{ $t('检验结果') }}
                            </th>
                            <th width="60">
                                {{ $t('缺陷数') }}
                            </th>
                            <th width="150">
                                {{ $t('缺陷描述') }}
                            </th>
                            <th>
                                {{ $t('备注') }}
                            </th>
                        </tr>
                        <tbody ref="tableTrBodylineCounting">
                            <tr v-for="(item, index) in lineCounting"
                                :key="index" 
                                :ref="`tableTrlineCounting${index}`" 
                                @click="trOnClick(index, 'lineCounting')"
                            >
                                <td>
                                    {{item.itemsCategoryTl}}
                                </td>
                                <td>
                                    {{item.itemsName}}
                                </td>
                                <td align="center">
                                    <Button 
                                        style="width: 40px;" 
                                        icon="eye" 
                                        type="info" 
                                        shape="circle" 
                                        @click="showTechnicalDetal(item.technicalRequirement)"
                                    />
                                </td>
                                <td>
                                    {{item.itemsLevel}}
                                </td>
                                <td>
                                    {{item.examinedTool}}
                                </td>
                                <td>
                                    {{item.inspectionLevelTl}}
                                </td>
                                <td>
                                    {{item.sampleQty}}
                                </td>
                                <td>
                                    <Select v-model="item.checkedResult"
                                            :disabled="readOnly"
                                            @on-change="(val) => checkedResultChange(val, index, 'lineCounting')"
                                    >
                                        <Option v-for="item2 in checkResultList2"
                                                :value="item2.value"
                                                :key="item2.value">{{item2.label}}
                                        </Option>
                                    </Select>
                                </td>
                                <td>
                                    <Input type="text" 
                                        v-model="item.ngQty"
                                        :disabled="item.checkedResult === 'NA' || readOnly"
                                        @on-blur="ngqtyOnChange(item.ngQty, index)"
                                    />
                                </td>
                                <td>
                                    <Input type="text" 
                                        v-model="item.ngInfo"
                                        :disabled="item.checkedResult === 'NA' || readOnly"
                                    />
                                </td>
                                <td>
                                    <Input type="text" v-model="item.remark" :disabled="readOnly"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </custom-panel>

            <custom-panel name="1" style="margin-top: 20px;">
                {{ $t('附件上传') }}
                <div slot="content">
                    <Row>
                        <Col :span="12">
                            <Upload
                                multiple
                                :format="fileTypeList"
                                :max-size=10240
                                ref="appendFile_ref"
                                :before-upload="handleBeforeUpload"
                                :on-error="errorUpload"
                                :on-success="successUpload"
                                :on-format-error="onFormatError"
                                :on-remove="removeFile"
                                :action="uploadFileUrl"
                                class="mupload-file"
                                v-if="!readOnly"
                            >
                                <Button type="ghost" icon="ios-cloud-upload-outline" style="width: 150px;" :loading="loading">{{ $t('选择上传文件') }}</Button>
                            </Upload>
                            <ul>
                                <li 
                                    class="file-item"
                                    v-for="(item, index) in uploadFileIds" 
                                    :key="'file_'+index" 
                                >
                                    <span>{{item.fileName}}</span>
                                    <span class="del-span" @click="fileDownLoad(item.fileId, item.isQms)">下载</span>
                                    <span v-if="!readOnly" class="del-span" @click="removeFileList(item, index)">删除</span>
                                </li>
                            </ul>
                            <div style="line-height:30px;color:red;">{{ $t('文件大小不能超过') }} 10M</div>
                        </Col>
                    </Row>
                </div>
            </custom-panel>
        </div>

        <!-- 迁移为独立功能 -->
        <Modal
            :title="$t('供方不良履历')"
            width="1200"
            v-model="MaterialBadRecordModal"
        >
            <material-bad-record :itemCode="itemCode" :autoSearch="autoSearch"></material-bad-record>
            <div slot="footer"></div>
        </Modal>

        <Modal v-model="importModal.show"
               :title="$t('导入')"
               width="300">
               <Upload
                    :action="importModal.url"
                    :data="importModal.importData"
                    :format="['xls', 'xlsx']"
                    :show-upload-list="false"
                    :before-upload="importBeforeUpload"
                    :on-error="importError"
                    :on-success="importSuccess"
                    :on-format-error="importFormatError"
                    
               >
               <Button :loading="importModal.loading" type="ghost" icon="ios-cloud-upload-outline">{{ $t('上传文件') }}</Button>
               </Upload>
               <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import CustomPanel from '@/components/awesome/page/panel/index';
import MaterialBadRecord from './MaterialBadRecord';
export default {
    name: 'ShipmentInspectionNew',
    components: {
        CustomPanel,
        MaterialBadRecord
    },
    computed: {
        /* 测量值最大个数 */
        maxNum() {
            return 5;
        },
    },
    data () {
        const validateBatchNumber = (rule, value, callback) => {
            if (!this.reportObj.batchNumber) {
                callback(this.$t('批次号不能为空'));
            } else {
                const len = value.replace(/[^\x00-\xff]/g, '011').length;
                if (len > 240) { // 限制240字节
                    callback(new Error(this.$t('批次号超长，请缩短内容')));
                }
            }
            callback();
        }
        const validateChecker = (rule, value, callback) => {
            if (!this.reportObj.checker) {
                callback(this.$t('检验员不能为空'));
            } else {
                const len = value.replace(/[^\x00-\xff]/g, '011').length; // 替换三字节字符（utf-8）
                if (len > 80) { // 限制80字节
                    callback(new Error(this.$t('检验员超长，请缩短内容')));
                }
            }
            callback();
        }
        const validatePlaceBrand = (rule, value, callback) => {
            if (!this.reportObj.placeBrand) {
                callback(this.$t('产地品牌不能为空'));
            } else {
                const len = value.replace(/[^\x00-\xff]/g, '011').length;
                if (len > 240) { // 限制240字节
                    callback(new Error(this.$t('【产地-品牌】超长，请缩短内容')));
                }
            }
            callback();
        }
        return {
            ckgColumns: [],
            
            queryLocal: this.$route.query.queryLocal,
            submitDisabled: false,
            qmsNumberTarget: 0,
            qmsNumberLoadList: [],
            qmsDataObj: {},
            readOnly: false,
            loading: false,
            reLoad: true,
            tableWidth: 1000,
            inputArrayList: [],
            checkResultList2: [],
            inputArray: 0,
            dataOptions: {
                disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                }
            },
            MaterialBadRecordModal: false,
            itemCode: '',
            autoSearch: false,
            MaterialBadRecordCount: 0,
            reportObj: {
                id: null,
                buCode: '',
                buId: null,
                buName: null,
                itemCode: '',
                itemDescription: null,
                unit: null,
                reportNumber: '',
                vendorCode: '',
                vendorName: null,
                vendorNameAlt: '',
                batchNumber: '',
                validStartTime: '',
                validEndTime: '',
                checkQuantity: '',
                checker: '',
                placeBrand: '',
                isValid: null,
                disableReason: null,
                commonStandardsId: null,
                commonStandardsName: null,
                specialStandardsId: '',
                specialStandardsName: '',
                inspectionLevel: '',
                inspectionLevelTl: '',
                examinedStringency: '',
                examinedStringencyTl: '',
                inspectionResult: null,
                inspectionResultT1: null,
                checkedResult: null,
                checkedResultTl: null,
                onetimePurchaseFlag: '',
                onetimePurchaseFlagTl: '',
                trialFlag: '',
                trialFlagTl: '',
                sampleQty: null,
                groupFlag: '',
                groupFlagName: '',
                attachment: null,
                sdpSynStatus: null,
                sdpSynMsg: null,
                sdpSynDate: null,
                sdpSynFrequency: null,
                sdpSynSerialnum: null,
                createdBy: '',
                creationDate: '',
                lastUpdatedBy: '',
                lastUpdateDate: '',
                attachmentList: [],
                lineDtoList: [],
            },
            lineMetering: [], // 计量
            lineCounting: [], // 技数
            reportObjCopy: {},
            reportRules: {
                buId: [
                    { required: true, type: 'number', message: this.$t('事业部不能为空'), trigger: 'change' }
                ],
                itemCode: [
                    { required: true, message: this.$t('物料编码不能为空'), trigger: 'change' }
                ],
                batchNumber: [
                    { required: true, message: this.$t('批次号不能为空'), trigger: 'blur' },
                    { validator: validateBatchNumber, trigger: 'blur' }
                ],
                placeBrand: [
                    { required: true, message: this.$t('产地品牌不能为空'), trigger: 'blur' },
                    { validator: validatePlaceBrand, trigger: 'blur' }
                ],
                checker: [
                    { required: true, message: this.$t('检验员不能为空'), trigger: 'blur' },
                    { validator: validateChecker, trigger: 'blur' }
                ],
                checkQuantity: [
                    { required: true, type: 'number', message: this.$t('生产数量不能为空'), trigger: 'blur' }
                ],
                validStartTime: [
                    { required: true, type: 'date', message: this.$t('请输入开始日期') }
                ],
                validEndTime: [
                    { required: true, type: 'date', message: this.$t('请输入结束日期') }
                ]
            },
            appendFile: null,
            appendFileLoadingStatus: false,
            buId: '',
            checkQuantity: '',

            uploadFileUrl: '/gscint/supplierfile/uploadFile',
            fileTypeList: ['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml'],
            uploadFileIds: [],

            importModal: {
                loading: false,
                show: false,
                url: '/gscapp/excel/loadExcelData',
                keyValue: [
                    {
                        key: this.$t('项目类别'),
                        value: 'itemsCategoryTl',
                    },
                    {
                        key: this.$t('项目名称'),
                        value: 'itemsName',
                    },
                    {
                        key: this.$t('单位'),
                        value: 'itemsPropertyUom',
                    },
                    {
                        key: this.$t('特性分级'),
                        value: 'itemsLevel',
                    },
                    {
                        key: this.$t('检验工具'),
                        value: 'examinedTool',
                    },
                    {
                        key: this.$t('检验水平'),
                        value: 'inspectionLevelTl',
                    },
                    {
                        key: this.$t('样本数'),
                        value: 'sampleQty',
                    },
                    {
                        key: this.$t('不良数'),
                        value: 'ngQty',
                    },
                    {
                        key: this.$t('最小值'),
                        value: 'min',
                    },
                    {
                        key: this.$t('最大值'),
                        value: 'max',
                    },
                    {
                        key: this.$t('基准值'),
                        value: 'criterion',
                    },
                    {
                        key: this.$t('测量值1'),
                        value: 'value1',
                    },
                    {
                        key: this.$t('测量值2'),
                        value: 'value2',
                    },
                    {
                        key: this.$t('测量值3'),
                        value: 'value3',
                    },
                    {
                        key: this.$t('测量值4'),
                        value: 'value4',
                    },
                    {
                        key: this.$t('测量值5'),
                        value: 'value5',
                    },
                ],
                importData: {},
            },
            sourceStorage: {},
            submitStatus: false
        };
    },
    methods: {
        /** 获取状态 */
        getSubmitStatusTip: function () {
            let url = '/gscint/sys/sysParam/queryDictionaryData';
            axios.get(url, {
                params: {
                    dictCode: 'CUX_INT_QMS_REPORT_NG_ORG',
                    isValid: 'Y'
                }
            }).then(
                res => {
                    let rep = res.data;
                    if (rep.success === true) {
                        console.log('rep', rep)
                        let curBuCode = this.reportObj.buCode
                        console.log('this.reportObj', this.reportObj)
                        let buCodeArr = (rep.data||[]).map(i => (i.code))
                        console.log('buCodeArr', buCodeArr)
                        this.submitStatus = buCodeArr.includes(curBuCode)
                        console.log('this.submitStatus ', this.submitStatus )
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: rep.msg
                        });
                    }
                }
            ).catch(() => {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        // 获取物料标准
        qmsCreatedReport () {
            this.loading = true;
            let url = '/gscint/sxInspection/qmsCreatedReport';
            let postData = {
                buId: this.buId, // 事业部Id
                itemCode:  this.itemCode, //物料编码
                checkQuantity:  this.checkQuantity, // 检验数量
                vendorCode: this.vendorCode, // 物料编码
            }
            
            axios.post(url, postData).then((res) => {
                this.loading = false;
                console.log('qmsCreatedReport', res);
                let resData = res.data.data;
                if (resData.code === '1') {
                    this.reportObj = resData.datas
                    this.setData(resData.datas);
                } else {
                    this.showErrorTips('loading', resData.msg);
                    this.submitDisabled = true;
                }
            }).catch(() => {
                this.showErrorTips();
                this.submitDisabled = true;
            });
        },
        // 查询单据详情
        querySxInspectionReportDetail(id) {
            if (!id) return
            axios.get(`/gscint/sxInspection/querySxInspectionReport?id=${id}`)
            .then((res) => {
                console.log('querySxInspectionReport', res);
                let resData = res.data.data;
                if (resData.code == '1') {
                    this.setData(resData.datas);
                }
            });
        },
        // 提交
        reportSubmit () {
            this.$refs.reportForm.validate((valid) => {
                if (valid) {
                    let hasNull = false;
                    this.lineMetering.map((item) => {
                        let sampleQty = item.sampleQty >= this.maxNum ? this.maxNum : item.sampleQty;
                        if (item.checkedResult !== 'NA') {
                            item.sampleMeteringCount.map((item2, key) => {
                                if (!item2 && key <= sampleQty - 1) {
                                    hasNull = true;
                                }
                            });
                        }
                    });
                    if (hasNull) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('测量值不允许为空，请完成填写')
                        });
                        return false;
                    }

                    let cannotSubmit = false;
                    let newList = this.lineMetering.concat(this.lineCounting);
                    if (this.checkResultList2.find((item) => item.value === 'NA')) {
                        if (newList.find((item) => item.checkedResult === 'NG')) {
                            cannotSubmit = true;
                        }
                    } else {
                        if (newList.find((item) => item.checkedResult !== 'OK')) {
                            cannotSubmit = true;
                        }
                    }
                    if (this.submitStatus) {
                        if (cannotSubmit) {
                            this.$Modal.confirm({
                                title: this.$t('common.warn'),
                                content: this.$t('存在不合格项，请确定是否继续提交该份报告'),
                                onOk: () => {
                                    this.reportSubmitFn()
                                },
                                onCancel: () => {

                                }
                            });
                        } else {
                            this.reportSubmitFn()
                        }
                    } else {
                        if (cannotSubmit) {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: this.$t('存在检验不合格项，禁止提交报告')
                            });
                            return false;
                        } else {
                            this.reportSubmitFn()
                        }
                    }
                }
            });
        },
        reportSubmitFn() {
            this.loading = true;
            let array = [];
            this.lineMetering.map((item) => {
                array.push({
                    ...item,
                    sampleMeteringCount: undefined,
                    checkedData: item.sampleMeteringCount.join()
                });
            });
            const { validEndTime, validStartTime, ...rest} = this.reportObj
            let lineDtoList = [
                ...array,
                ...this.lineCounting
            ]
            let submitData = {
                ...rest,
                validEndTime: moment(validEndTime).format('YYYY-MM-DD 23:59:59'),
                validStartTime: moment(validStartTime).format('YYYY-MM-DD 00:00:00'),
                attachmentList: this.uploadFileIds,
                lineDtoList: lineDtoList
            }
            console.log(submitData)

            axios.post('/gscint/sxInspection/saveReport', submitData)
            .then((res) => {
                this.loading = false;
                if (res.data.data.code === '-1') {
                    this.showErrorTips();
                    return false;
                } else if (res.data.data.code === '1') {
                    this.$Modal.success({
                        content: this.$t('提交成功')
                    });
                    // 返回列表页
                    setTimeout(() => {
                        this.$closeTab({
                            name: 'shipmentInspectionAdd',
                        });
                        this.$router.push({
                            name: 'firstInspectionQueryList'
                        });
                    }, 1500);
                } else {
                    this.showErrorTips('loading', res.data.data.msg);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 物料不良履历
        badItemHistoryClick () {},
        // 供方不良履历
        MaterialBadRecordModalClick () {
            this.MaterialBadRecordModal = true;
            setTimeout(() => {
                this.autoSearch = true;
            }, 200);
        },
        // 页面跳转
        goPageByName (name) {
            this.$router.push({
                name: name,
                query: name === 'itemStandard' ? {
                    itemCode: this.itemCode
                } : undefined
            });
        },
        trOnClick(rowIndex, type) {
            this.trBackgroundChange(type, rowIndex);
        },
        // 行选中修改颜色
        trBackgroundChange (tableType, rowIndex) {
            let tableTrs = this.$refs[`tableTrBody${tableType}`].children;
            for (let i in tableTrs) {
                for (let j in tableTrs[i].children) {
                    try {
                        tableTrs[i].children[j].style.background = '#FFF';
                    } catch (err) {
                        // console.log(err);
                    }
                }
            }
            for (let i in this.$refs[`tableTr${tableType}${rowIndex}`][0].children) {
                try {
                    this.$refs[`tableTr${tableType}${rowIndex}`][0].children[i].style.background = '#88c1f4';
                } catch (err) {
                    // console.log(err);
                }
            }
        },
        // 检验结果
        checkedResultChange(val, index, type) {
            console.log(val, index, type)
            let arr = this[type][index].sampleMeteringCount;
            if (val === 'NA') {
                let newArray = [];
                arr.map((item, index) => {
                    newArray.push('');
                });
                this[type][index].sampleMeteringCount = newArray;
                this.reLoad = false;
                setTimeout(() => {
                    this.reLoad = true;
                }, 0);
            }
            if (val === 'OK' && type === 'lineCounting') {
                this[type][index].ngQty = 0;
            }
            if (val === 'NG') {
                this.reportObj.inspectionResultT1 = '不合格'
            }
            if (type === 'lineCounting') {
                let isAllResArr = this.lineCounting.map(i => (i.checkedResult))
                if (isAllResArr.includes('NG')) {
                    this.reportObj.inspectionResultT1 = '不合格'
                } else {
                    this.reportObj.inspectionResultT1 = '合格'
                }
            } else {
                let isAllResArr = this.lineMetering.map(i => (i.checkedResult))
                if (isAllResArr.includes('NG')) {
                    this.reportObj.inspectionResultT1 = '不合格'
                } else {
                    this.reportObj.inspectionResultT1 = '合格'
                }
            }
        },
        // 测量值修改
        // itemsPropertyFloorTerms 最小值条件  itemsPropertyCeilingTerms 最大值条件
        sampleMeteringOnChange (row, val, trIndex, tdIndex, itemsPropertyFloorTerms, itemsPropertyCeilingTerms, isShowTips) {
            let isError = false;
            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
            if (!isNaN(val) && numberRule.test(val)) {
                if (!this.returnCompare(itemsPropertyFloorTerms, val, row.itemsPropertyFloor) || !this.returnCompare(itemsPropertyCeilingTerms, val, row.itemsPropertyCeiling)) {
                    if (isShowTips) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('送货检验判定: 不合格.')
                        });
                    }
                    isError = true;
                }
            } else {
                if (isShowTips) {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('测量值必须为有效数值')
                    });
                }
                isError = true;
            }
            if (isError) {
                if (isShowTips) {
                    this.lineMetering[trIndex].checkedResult = 'NG';
                    this.reportObj.inspectionResultT1 = '不合格'
                }
            } else {
                if (isShowTips) {
                    let allOk = true;
                    let isTrue = true;
                    this.lineMetering[trIndex].sampleMeteringCount.map((item) => {
                        let val = !this.sampleMeteringOnChange(row, item, trIndex, tdIndex, itemsPropertyFloorTerms, itemsPropertyCeilingTerms, false);
                        if (!val) {
                            allOk = false;
                        }
                        if (this.lineMetering[trIndex].sampleMeteringCount[0] !== item) {
                            isTrue = false;
                        }
                    });
                    if (allOk) {
                        this.lineMetering[trIndex].checkedResult = 'OK';
                        this.reportObj.inspectionResultT1 = '合格'
                    }
                    if (this.lineMetering[trIndex].sampleQty > 1 && isTrue) {
                        this.$Modal.warning({
                            title: this.$t('common.warn'),
                            content: this.$t('填写数据一样，涉嫌数据作假，请重新确认填写数据情况')
                        });
                    }
                }
            }
            return isError;
        },
        // 缺陷数修改
        ngqtyOnChange (val, trIndex) {
            console.log('ngqtyOnChange', val, trIndex);
            if (!isNaN(val) && val >= 0) {
                if (val > 0) {
                    this.lineCounting[trIndex].checkedResult = 'NG';
                    this.reportObj.inspectionResultT1 = '不合格'
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('送货检验判定: 不合格.')
                    });
                }
            } else {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('缺陷数必须大于或等于0')
                });
                this.lineCounting[trIndex].checkedResult = '';
                this.lineCounting[trIndex].ngQty = '';
            }
            let isAllResArr = this.lineCounting.map(i => (i.checkedResult))
            if (isAllResArr.includes('NG')) {
                this.reportObj.inspectionResultT1 = '不合格'
            } else {
                this.reportObj.inspectionResultT1 = '合格'
            }
        },
        handleBeforeUpload (file) {
            const check = this.uploadFileIds.length < 9;
            if (!check) {
                this.$Modal.error({
                    content: this.$t('最多只能上传9个文件')
                });
                this.loading = false
            }
            this.loading = true;
            return check;
            
        },
        onFormatError () {
            this.loading = false;
            this.$Modal.error({
                content: `${this.$t('附件只支持')}${this.fileTypeList.join()}${this.$t('格式')}`
            });
        },
        removeFile (file, fileList) {
            this.uploadFileIds = this.uploadFileIds.find((item) => item.fileId !== file.response.data.docId) || [];
        },
        removeFileList(item, index) {
            this.uploadFileIds.splice(index, 1)
        },
        errorUpload () {
            this.loading = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('上传失败，请稍后再试')
            });
        },
        successUpload (response, file, fileList) {
            this.loading = false;
            this.uploadFileIds.push({
                fileId: response.data.docId,
                fileName: response.data.fileName,
                fileSize: file.size
            });
        },
        // 对比数据结果 （根据qms返回的校验规则来指定比较方案）
        returnCompare (PROPERTY, inputVal, minOrMax) {
            let flag = true;
            inputVal = parseFloat(inputVal);
            minOrMax = parseFloat(minOrMax);
            if (minOrMax || minOrMax === 0) {
                if (PROPERTY === '＞') {
                    flag = inputVal > minOrMax;
                } else if (PROPERTY === '≥') {
                    flag = inputVal >= minOrMax;
                } else if (PROPERTY === '＜') {
                    flag = inputVal < minOrMax;
                } else if (PROPERTY === '≤') {
                    flag = inputVal <= minOrMax;
                }
            } else {
                flag = true;
            }
            return flag;
        },
        
        setData (data = {}) {
            let dataCopy = JSON.parse(JSON.stringify(data))
            const {lineDtoList = [], attachmentList = [],inspectionResult, ...rest} = dataCopy
            this.reportObj = {...rest, inspectionResultT1: inspectionResult}
            let lineDtoListCopy = JSON.parse(JSON.stringify(lineDtoList))
            this.lineMetering = lineDtoListCopy.filter((item) => item.itemsProperty === 'Metering') // 计量
            this.lineCounting = lineDtoListCopy.filter((item) => item.itemsProperty === 'Counting') // 计数
            
            // 计量表格处理
            this.lineMetering.map((item, index) => {
                this.inputArrayList.push(item.sampleQty > this.maxNum ? this.maxNum : item.sampleQty);
            });
            if (this.inputArrayList.length > 0) {
                this.inputArray = Array(Math.max(...this.inputArrayList));
            }
            this.lineMetering.map((item, index) => {
                let newArray = [];
                if (!this.readOnly) {
                    for (let i = 0; i < this.inputArrayList[index]; i++) {
                        newArray.push('');
                    }
                } else {
                    try {
                        newArray = this.lineMetering[index].checkedData.split(',');
                    } catch (err) {
                        console.log('error', err);
                    }
                }
                this.lineMetering[index].sampleMeteringCount = newArray;
            });
            this.tableWidth = 710 + 40 * (this.inputArray.length + 1);

            // 附件
            this.uploadFileIds = data.attachmentList || [];
            // 编辑
            if (!this.readOnly) {
                for (let key in this.sourceStorage) {
                    // batchNumber validStartTime validEndTime checkQuantity checker placeBrand 由前端从上一个页面带入
                    this.reportObj[key] = this.sourceStorage[key];
                }
                // 计数表格
                this.lineCounting.map((item, index) => {
                    this.lineCounting[index].checkedResult = 'OK';
                });
            }
            this.getSubmitStatusTip()
        },
        // 出货检验报告是否显示NA选项
        GetCheckItemRemoveNA () {
            let list = [{value: 'OK', label: 'OK'}, {value: 'NG', label: 'NG'}];
            let list2 = [{value: 'NA', label: 'NA'}];
            this.checkResultList2 = list.concat(list2);
            axios.get('/gscint/sys/sysParam/queryDictionaryData?dictCode=CUX_BATCH_NOT_NA&isValid=Y')
            .then((res) => {
                if (res.data.data) {
                    let dictList = res.data.data;
                    let buIds = [];
                    dictList.forEach((item) => {
                        buIds.push(item.value);
                    });
                    if (buIds.includes(String(this.buId))) {
                        this.checkResultList2 = list;
                    }
                }
            });
        },
        createArray (num) {
            let array = [];
            for (let i = 0; i < num; i++) {
                array.push(i);
            }
            return array;
        },
        showTechnicalDetal (html) {
            this.$Modal.info({
                content: html
            });
        },
        // 附件下载
        fileDownLoad (docId, isQms = false) {
            if (!isQms) {
                window.open(`/gscint/supplierfile/downloadFile?docId=${docId}`);
            } else {
                window.open(`/qms/qms-api/meixin/DownloadFile?id=${docId}`);
            }
        },
        // 下载报告
        async downloadReport () {
            let barcodeNumbers = '';
            //await axios.post('/gscapp/inspectionReport/queryAlreadyMatchReportAndOrder', {
            await axios.get('/gscint/sxInspection/queryDeliveryOrder', {
                params: {
                    reportNumber: this.reportObj.reportNumber,
                }
            })
            .then((res) => {
                let list = res.data.data.datas || []
                let ids = [];
                if (list) {
                    list.forEach((item) => {
                        ids.push(item.barcodeNumber);
                    });
                    barcodeNumbers = ids.join();
                }
            });
            
            let dtls = JSON.parse(JSON.stringify(this.lineMetering));
            let dtls2 = JSON.parse(JSON.stringify(this.lineCounting));
            for (let i in dtls) {
                dtls[i]['itemsPropertyTl'] = '计量';
                if (dtls[i].checkedData) {
                    let sampleQty = dtls[i].sampleQty;
                    if (sampleQty < this.maxNum) {
                        if (dtls[i].checkedData.split(',').length > sampleQty) {
                            dtls[i].checkedData = dtls[i].checkedData.split(',').slice(0, sampleQty).join();
                        }
                    }
                }
            }
            for (let i in dtls2) {
                dtls2[i]['itemsPropertyTl'] = '计数';
                dtls2[i].itemsPropertyBenchmark = '';
                dtls2[i].itemsPropertyCeiling = '';
                dtls2[i].itemsPropertyFloor = '';
            }
            let DTLS = dtls.concat(dtls2);
            for (let i in DTLS) {
                if (DTLS[i].technicalRequirement) {
                    DTLS[i].technicalRequirement = DTLS[i].technicalRequirement.replace(/<\/?[^>]*>/g, '').replace(/[ | ]*\n/g, '\n').replace(/\n[\s| | ]*\r/g, '\n');
                }
            }
            console.log('this.reportObj', this.reportObj)
            let {reportNumber, vendorNameAlt, checkQuantity, itemCode, buName, itemDescription, checker, batchNumber, groupFlag, creationDate} = this.reportObj;
            let template = {
                examinedNo: reportNumber,
                supplierDesc: vendorNameAlt,
                batchNo: checkQuantity,
                itemCode,
                orgDesc: buName,
                itemDesc: itemDescription,
                checker,
                batchInfo: batchNumber,
                groupFlag,
                barcodeNumbers,
                DTLS,
                creationDate
            };
            let dataFormat = {
                ...template
            }
            /* 云打印 */
            dataFormat.DTLS = dataFormat.DTLS.map((item) => {
                if (item.checkedData) {
                    item.checkedData.split(',').forEach((item2, index) => {
                        item[`checkedData${index + 1}`] = item2;
                    });
                }
                item.checkedResult = item.checkedResult === 'OK' ? '合格' : 'NA';
                return item;
            });
            if (this.isCloundPrint({reportlets: dataFormat}, '', this.vendorCode, ['DelOrderReport2'], 'DelOrderReport2')) {
                // return false;
            }
            var config = {
                cpt: 'srm/DelOrderReport2.cpt',
                data: template,
                printType: 'diePay'
            };
            this.$mprint.doURLPDFprint(config);
        },
        qmsNumberTargetChange (index) {
            this.qmsNumberTarget = index;
            this.qmsCreatedReport();
        },
        getDictByCode (dictCode) {
            axios.get('/gscint/sys/sysParam/queryDictionaryData', {
                params: {
                    dictCode,
                    isValid: 'Y'
                }
            })
            .then((res) => {
                this[dictCode] = res.data.data;
            });
        },
        // 键盘按键
        nextInput (event, trIndex, tdIndex) {
            // 38 40
            let index = tdIndex;
            for (let i = 0; i < trIndex; i++) {
                index += this.inputArrayList[i];
            }
            let doms = document.getElementsByClassName('number-input');
            if (event.keyCode === 38) {
                if (doms[index - 1]) {
                    let dom = this.inputFocus(index - 1, doms);
                    dom.focus();
                }
            } else if (event.keyCode === 40 || event.keyCode === 13) {
                if (doms[index + 1]) {
                    let dom = this.inputFocus(index + 1, doms);
                    dom.focus();
                }
            }
        },
        inputFocus (key, doms) {
            return doms[key].getElementsByClassName('m-input')[0];
        },
        
        /* 下载计量检验导入模板 */
        exportTemplate() {
            this.importModal.loading = true;
            const dataList = this.reportObj.dtls.reduce((prev, { itemsCategoryTl, itemsName, itemsPropertyUom, itemsLevel, examinedTool, inspectionLevelTl, sampleQty, itemsPropertyFloor, itemsPropertyFloorTerms, itemsPropertyCeilingTerms, itemsPropertyCeiling, itemsPropertyBenchmark, ngQty }) => {
                return prev.concat({
                    itemsCategoryTl,
                    itemsName,
                    itemsPropertyUom,
                    itemsLevel,
                    examinedTool,
                    inspectionLevelTl,
                    sampleQty,
                    ngQty,
                    min: itemsPropertyFloorTerms + (itemsPropertyFloor || ''),
                    max: itemsPropertyCeilingTerms + (itemsPropertyCeiling || ''),
                    criterion: itemsPropertyBenchmark || '',
                    value1: '',
                    value2: '',
                    value3: '',
                    value4: '',
                    value5: '',
                });
            }, [])
            axios.post('/gscapp/excel/uploadData', {
                dataList
            })
                .then((res) => {
                    const { datas } = res.data.data;
                    if (datas) {
                        axios({
                            url: '/gscapp/excel/exportExcel',
                            method: 'get',
                            params: {
                                paraJson: JSON.stringify({
                                    fileName: `计量检验`,
                                    sheetName: '计量检验',
                                    dataId: datas,
                                    keyValue: this.importModal.keyValue,
                                })
                            },
                            headers: { 'content-type': 'application/json; charset=utf-8' },
                            responseType: 'blob',
                        })
                            .then((res) => {
                                this.downloadFile(res.data, `${this.vendorCode}_${this.$route.query.itemCode}_${moment().format('YYYY-MM-DD')}.xls`);
                            })
                            .finally(() => {
                                this.importModal.loading = false;
                            });
                    }
                })
                .catch(() => {
                    this.importModal.loading = false;
                    this.showErrorTips();
                })
        },
        importError() {
                this.importModal.loading = false;
                this.$Modal.error({
                    content: this.$t('common.error1')
                });
            },
        /* 计量检验模板导入成功 */
        importSuccess(res) {
            this.importModal.loading = false;
            const { datas } = res?.data || {};
            if (datas) {
                datas.forEach((impItem) => {
                    this.reportObj.dtls.forEach((item, index) => {
                        /* 根据项目类别	项目名称进行匹配 */
                        if (impItem.itemsCategoryTl + impItem.itemsName === item.itemsCategoryTl + item.itemsName) {
                            for (const i in item.sampleMeteringCount) {
                                item.sampleMeteringCount[i] = impItem[`value${+i + 1}`]
                                setTimeout(() => {
                                    this.sampleMeteringOnChange(item, item.sampleMeteringCount[i], index, i, item.itemsPropertyFloorTerms, item.itemsPropertyCeilingTerms, true);
                                }, index);
                            }
                        }
                    })
                });
                this.$Modal.success({
                    content: this.$t('导入成功'),
                });
            } else {
                this.$Modal.error({
                    content: this.$t('common.error1')
                });
            }
            this.importModal.show = false;
        },
        importFormatError() {
            this.importModal.loading = false;
            this.$Modal.warning({
                content: this.$t('请上传正确的导入模板')
            });
        },
        importBeforeUpload() {
            this.importModal.loading = true;
        },
        importMeasure(event, isImport) {
            event.stopPropagation();
            if (isImport) {
                this.importModal.show = true
            } else {
                this.exportTemplate();
            }
        },
    },
    async mounted () {
        let query = this.$route.query;
        this.itemCode = query.itemCode;
        this.buId = query.buId;
        this.checkQuantity = query.checkQuantity;
        
        try {
            // 是否只读
            if (!query.readOnly) {
                this.readOnly = false
                let reportData = JSON.parse(sessionStorage.getItem('outgoingInspectionReportAdd'));
                this.sourceStorage = {
                    ...reportData,
                    validEndTime: new Date(reportData.validEndTime),
                    validStartTime: new Date(reportData.validStartTime)
                };
                this.qmsCreatedReport();
            } else {
                this.readOnly = true;
                this.querySxInspectionReportDetail(query.id)
            }
        } catch (err) {
            console.log(err);
        }
        
        this.GetCheckItemRemoveNA();
        
        /* 导入参数初始化 */
        this.importModal.importData = {
            keyValue: JSON.stringify(this.importModal.keyValue),
        }
    }
};
</script>
<style lang="less" scoped>
.title-bar {
    background-color: #F2F2F2;
    border: 1px solid #dddee1;
    padding: 10px 20px;
    button {
        float: right;
    }
    span {
        border-left: 5px solid #3AA2EB;
        padding: 0 7px;
        font-size: 15px;
        font-weight: 400;
        height: 32px;
        line-height: 32px;
    }
}
/deep/ .m-form .m-form-item-label {
    padding-right: 5px;
}
/deep/ .report-input .m-input{
    padding: 4px;
}
.table {
    th, td{
        height: 50px;
        background: #f8f8f9;
        padding: 0 5px;
        border: 1px solid #e9eaec;
    }
    td {
        background: #FFF;
        word-wrap: break-word;
        white-space: normal;
        word-break: break-all;
    }
}
.shipment-btns {
    border-bottom: 1px solid #CCC;
    height: 40px;
    margin: 10px;
    .item {
        display: inline-block;
        margin-right: 10px;
        padding: 0 10px;
        border-radius: 3px;
        border: 1px solid #CCC;
        cursor: pointer;
        background: #f5f7f9;
        line-height: 40px;
        position: relative;
        top: -2px;
    }
    .item-target {
        background: #FFF;
        top: 0;
        border-bottom: none;
    }
}
/deep/ .m-table-fixed-body{
    z-index: 99;
}
.mupload-file{
    /deep/.m-upload-list{
        display: none;
    }
}
.file-item{
    display: flex;
    align-items: center;
    margin-top: 6px;
    .del-span{
        color: #3AA2EB;
        margin-left: 10px;
        padding: 0 4px;
        cursor: pointer;
    }
}
</style>